module.exports = __webpack_public_path__ + "static/media/step2.25726bb7.png";